import { useStore } from '../state/store';
import { closeDoc } from '../app/session';
import { formatBytes } from '../lib/format';
import { docSummary, summaryLabel } from '../lib/report';

export function FileList() {
  const docs = useStore((s) => s.docs);
  const activeId = useStore((s) => s.activeId);
  const setActive = useStore((s) => s.setActive);
  return (
    <div className="filelist">
      {docs.length === 0 && <div className="section muted small">No files yet.</div>}
      {docs.map((d) => {
        const s = d.status === 'ready' && !d.inspecting && d.checks.length > 0 ? docSummary(d.checks) : null;
        return (
        // The row itself is a plain container: a real <button> inside a
        // role="button" element is nested interactive content, which screen
        // readers may not expose at all (the close button would be
        // unreachable). Instead the name/meta IS the select button and the
        // close button is its sibling, so both are in the tab order, both get
        // native Enter/Space activation, and neither triggers the other.
        <div key={d.id} className={`file${d.id === activeId ? ' active' : ''}`}>
          <button
            type="button"
            className="file-select"
            aria-pressed={d.id === activeId}
            onClick={() => setActive(d.id)}
            title={d.error ?? d.name}
          >
            <span className="file-name">{d.name}</span>
            <span className="file-meta muted small">
              {d.status === 'loading' && 'loading…'}
              {d.status === 'error' && <span className="pill fail">error</span>}
              {d.status === 'ready' && d.meta && `${d.meta.width}×${d.meta.height} · ${Math.round(d.meta.dpi)} dpi${d.meta.dpiAssumed ? ' (assumed)' : ''} · ${formatBytes(d.size)}`}
              {d.running && ' · running'}
            </span>
            {s && <span className={`pill ${s.fail ? 'fail' : s.warn ? 'warn' : 'pass'}`}>{summaryLabel(s)}</span>}
          </button>
          {d.status === 'error' && <div className="file-note fail small">{d.error}</div>}
          {d.runError && <div className="file-note warn small">Run failed: {d.runError}</div>}
          {/* A 24-px target in the app's own text colour, not the 20x18 px of
              dim grey the audit found (#24) — and no confirm dialog: closing says
              so at the bottom of the viewer, with Undo beside it for ten
              seconds (`closeDoc`). */}
          <button type="button" className="file-close" onClick={() => void closeDoc(d.id)} aria-label={`Close ${d.name}`} title={`Close ${d.name}`}>×</button>
        </div>
        );
      })}
    </div>
  );
}
